import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=094cc87d&scoped=true&"
import script from "./Wizard.vue?vue&type=script&lang=ts&"
export * from "./Wizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094cc87d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094cc87d')) {
      api.createRecord('094cc87d', component.options)
    } else {
      api.reload('094cc87d', component.options)
    }
    module.hot.accept("./Wizard.vue?vue&type=template&id=094cc87d&scoped=true&", function () {
      api.rerender('094cc87d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/Wizard.vue"
export default component.exports